// Update 1 item trong list data
/** Item type have to include { id: string | number } */
function updateOneItemInList<T extends { id: string | number }>(
  data: T,
  lisData?: T[]
) {
  if (!Array.isArray(lisData)) return undefined
  const list = [...lisData]
  let item = list.find((x) => x.id === data.id)
  if (!item) return undefined

  item = Object.assign(item, data)

  return list
}

export default updateOneItemInList
